export default __webpack_public_path__ + "static/media/Ömer.0c3a1682.jpeg";